module.exports = __webpack_public_path__ + "img/mile5m-m@1.04dec6b8.webp";